<template>
  <transition name="modal">
    <div class="confirm__mask">
      <div
        :class="['confirm__container', { 'confirm__container--full': full }]"
      >
        <Button
          v-if="hasCloseButton"
          icon
          :routine="closeModal"
          class="confirm__close"
        >
          <Icon
            icon="cross"
            size="24"
          />
        </Button>

        <div class="confirm__header">
          <slot name="header" />
        </div>

        <div class="confirm__body">
          <slot name="body" />
        </div>

        <div class="confirm__footer">
          <Button
            :routine="closeModal"
            class="confirm__no"
            :text="cancelText || 'No'"
          />
          <Button
            red
            :routine="confirmAction"
            class="confirm__yes"
            :text="confirmText || 'Yes'"
            :disabled="confirmButtonIsDisabled"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/Button.vue'
import Icon from '@/components/Icon.vue'

export default {
  name: 'Confirm',

  components: {
    Button,
    Icon
  },

  props: {
    hasCloseButton: Boolean,
    full: Boolean,
    cancelText: String,
    confirmText: String
  },

  data () {
    return {
      confirmButtonIsDisabled: false
    }
  },

  methods: {
    /**
     * @returns {event}
     */
    closeModal () {
      return this.$emit('close')
    },

    /**
     * @returns {event}
     */
    confirmAction () {
      this.confirmButtonIsDisabled = true

      return this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm__mask {
  @include size(100%);
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(10px);
  transition: opacity 0.3s ease;
  z-index: 9999;

  &::before {
    content: '';
    @include size(100%);
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
  }
}

.confirm__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  max-width: 320px;
  margin: 0px auto;
  padding: 32px;
  border-radius: $border-radius-default;
  box-shadow: $shadow-default;
  background-color: $white;
  transition: all 0.3s ease;
  z-index: 9999;

  &--full {
    @include size(calc(100% - 64px));
    max-width: 100%;

    .confirm__body {
      @include size(100%);

      iframe {
        @include size(100%);
      }
    }
  }
}

.confirm__close {
  position: absolute;
  top: 8px;
  right: 8px;
}

.confirm__header,
.confirm__body,
.confirm__footer {
  display: flex;
  justify-content: center;
}

.confirm__header {
  margin-bottom: 8px;
  font-size: 22px;
  font-weight: 500;
  color: $grey-blue;
  opacity: 0.7;
}

.confirm__body {
  margin: 0 auto;
  font-size: 14px;
  text-align: center;
  color: $grey-light;
}

.confirm__footer {
  justify-content: space-around;
  align-items: center;
  margin-top: $gutter;

  * {
    width: 120px;
  }
}

.confirm__no {
  margin-right: 10px;
}

.confirm__yes {
  margin-left: 10px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
